import { HFlow, Text, VFlow } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { Cns, Cpf, Telefone } from 'components/label'
import { intervalToDuration } from 'date-fns'
import React, { Fragment } from 'react'
import { formatDate } from 'util/date/formatDate'
import { formatDurationToMonthsAndDays } from 'util/date/formatDuration'
import { humanizeAge } from 'util/date/humanize-age'
import { formatNumber } from 'util/number'

import { CidadaoListagemGeralQueryModel } from '../../model/model-acompanhamentoCondicaoSaudeListaTematica'

export const renderInformacao = (row: CidadaoListagemGeralQueryModel) => {
  const cpfComponent = row.cpfCidadao && (
    <HFlow hSpacing={0.25} alignItems='center'>
      <Text fontWeight='bold'>CPF</Text>
      <Cpf value={row.cpfCidadao} />
    </HFlow>
  )
  const cnsComponent = row.cnsCidadao && (
    <HFlow hSpacing={0.25} alignItems='center'>
      <Text fontWeight='bold'>CNS</Text>
      <Cns value={row.cnsCidadao} />
    </HFlow>
  )

  return (
    <VFlow vSpacing={0}>
      <Text fontWeight='bold'>{row.nomeSocialCidadao?.titleCase() ?? row.nomeCidadao?.titleCase()}</Text>
      {cpfComponent ?? cnsComponent ?? <Text>Pessoa sem CNS e CPF</Text>}
      <HFlow hSpacing={0.25} alignItems='center'>
        <Text fontWeight='bold'>Idade: </Text>
        <Text>{humanizeAge(row.dataNascimentoCidadao)}</Text>
      </HFlow>
      <HFlow hSpacing={0.25} alignItems='center'>
        <Text fontWeight='bold'>Microárea: </Text>
        <Text>{row.microarea ?? 'Não informada'}</Text>
      </HFlow>
    </VFlow>
  )
}

export const renderTelefone = (row: CidadaoListagemGeralQueryModel) => {
  return !row?.telefoneCelular && !row?.telefoneContato && !row?.telefoneResidencial ? (
    <Text>-</Text>
  ) : (
    <HFlow hSpacing={0.25}>
      {row.telefoneResidencial && <Telefone value={row.telefoneResidencial} />}
      {row.telefoneCelular && (
        <Fragment>
          {row.telefoneResidencial && ' | '}
          <Telefone value={row.telefoneCelular} />
        </Fragment>
      )}
      {row.telefoneContato && (
        <Fragment>
          {(row.telefoneResidencial || row.telefoneCelular) && ' | '}
          <Telefone value={row.telefoneContato} />
        </Fragment>
      )}
    </HFlow>
  )
}

export const renderUltimasMedicoes = (row: CidadaoListagemGeralQueryModel) => (
  <VFlow vSpacing={0.2}>
    <HFlow hSpacing={0.25}>
      <Text fontWeight='bold'>Peso/Altura: </Text>
      {row.ultimaMedicaoPeso
        ? `${formatNumber(Number(row.ultimaMedicaoPeso), 2)}kg/${formatNumber(
            Number(row.ultimaMedicaoAltura),
            1
          )}cm em ${formatDate(row.dataUltimaMedicaoPesoAltura)} `
        : '-'}
    </HFlow>
    <HFlow hSpacing={0.25}>
      <Text fontWeight='bold'>P.A.: </Text>
      {row.ultimaMedicaoPressaoArterial
        ? `${row.ultimaMedicaoPressaoArterial}mmHg em ${formatDate(row.dataUltimaMedicaoPressaoArterial)}`
        : '-'}
    </HFlow>
  </VFlow>
)

export const renderUltimoAtend = (
  {
    dataUltimoAtendimentoMedico,
    dataUltimoAtendimentoEnfermagem,
    dataUltimaVisitaDomiciliar,
    dataUltimoAtendimentoOdontologico,
  }: CidadaoListagemGeralQueryModel,
  getServerTimeNow: () => Date
) => {
  const atendimentos = [
    { title: 'Médica:', data: dataUltimoAtendimentoMedico },
    { title: 'Enfermagem:', data: dataUltimoAtendimentoEnfermagem },
    { title: 'Odontológico:', data: dataUltimoAtendimentoOdontologico },
    { title: 'Visita domiciliar:', data: dataUltimaVisitaDomiciliar },
  ]

  const now = getServerTimeNow()

  return (
    <VFlow vSpacing={0}>
      {atendimentos.map(({ title, data }) => {
        const parsedDate = data ? new Date(data) : null

        return (
          <HLabel key={title} title={title} placeholder='-'>
            {parsedDate && formatDurationToMonthsAndDays(intervalToDuration({ start: parsedDate, end: now }))}
          </HLabel>
        )
      })}
    </VFlow>
  )
}
